<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="category-product-list tabulator-parent">
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-cubes"></i> {{ _('Products') }}</h3>
          <div class="component-title-buttons">
            <button class="newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog"><i class="fa fa-fw fa-plus"></i><span class="hidden-xs"> {{ _('Create new...') }}</span></button>
          </div>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" :class="'hidden-col-md hidden-col-lg hidden-col-sm btn btn-info' + (listFilterVisible ? ' active' : '')" :title="(listFilterVisible ? 'Piilota rajaimet' : 'Näytä rajaimet')" @click="listFilterVisible = !listFilterVisible"><i :class="'fa fa-fw ' + (listFilterVisible ? 'fa-caret-up' : 'fa-sliders')"></i></button>
                <button type="button" :class="'hidden-col-xs btn btn-success'" :title="_('Search')"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <template v-if="listFilterVisible">
          <div class="list-filter-col">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">{{ _('Display') }}</div>
                <select class="form-control" id="productTypeFilter" v-model="type">
                  <option value="all">{{ _('All products') }}</option>
                  <option value="0">{{ _('Buyable products') }}</option>
                  <option value="0-5-generic">{{ _('Tickets') }}</option>
                  <option value="0-6-generic">{{ _('Value cards') }}</option>
                  <option value="0-8-generic">{{ _('Content products') }}</option>
                  <option value="1">{{ _('Reservable products') }}</option>
                  <option value="category">{{ _('Categories') }}</option>
                  <optgroup :label="_('Reservable products')">
                    <option value="1-0-generic">{{ _('Reservable') }}</option>
                    <option value="1-1-generic">{{ _('Reservable cabin') }}</option>
                    <option value="1-2-generic">{{ _('Activity') }}</option>
                    <option value="1-3-generic">{{ _('Transportation') }}</option>
                    <option value="1-1001-generic">{{ _('Hotellinx') }}</option>
                    <option value="1-1-hotelroom">{{ _('Hotel room') }}</option>
                    <option value="1-1-cottage">{{ _('Cottage') }}</option>
                    <option value="1-1-villa">{{ _('Villa') }}</option>
                    <option value="1-1-otheraccommodation">{{ _('Other accommodation') }}</option>
                    <option value="1-0-rentalgear">{{ _('Rental gear') }}</option>
                    <option value="1-0-rentalequipment">{{ _('Rental equipment') }}</option>
                    <option value="1-0-meetingvenue">{{ _('Meeting venue') }}</option>
                    <option value="1-0-partyvenue">{{ _('Party venue') }}</option>
                    <option value="1-0-othervenue">{{ _('Other venue') }}</option>
                    <option value="1-2-reservableservice">{{ _('Reservable service') }}</option>
                    <option value="1-2-eventsservice">{{ _('Events service') }}</option>
                    <option value="1-2-trip">{{ _('Trip') }}</option>
                    <option value="1-2-guidedtrip">{{ _('Guided trip') }}</option>
                    <option value="1-4-generic">{{ _('Event') }}</option>
                    <option value="1-4-movie">{{ _('Movie') }}</option>
                    <option value="1-4-theater">{{ _('Theater') }}</option>
                    <option value="1-4-concert">{{ _('Concert') }}</option>
                  </optgroup>
                  <option value="archived">{{ _('Archived products') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="list-filter-col" v-if="showFilters">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">{{ _('Filter') }}</div>
                <select class="form-control" id="productTagFilter" v-model="tag">
                  <option value="">{{ _('No filter') }}</option>
                  <optgroup :label="_('By tag')" v-if="adminTags">
                    <option v-for="tag in adminTags" class="tagOption" :value="tag.id">{{ tag.title }}</option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
          <div class="button-col">
            <button class="btn btn-default" type="button" v-on:click="toggleMultiSelect"><template v-if="tableOptions.selectable"><i class="fa fa-fw fa-window-close"></i><span class="hidden-xs"> {{ _('Cancel') }}</span></template><template v-else><i class="fa fa-fw fa-check-square"></i><span class="hidden-xs"> {{ _('Select') }}</span></template></button>
          </div>
        </template>
      </div>
      <div class="list-filter-row space-between" v-if="tableOptions.selectable">
        <div class="flex-row">
        <button class="btn btn-warning" type="button" v-on:click="archiveSelectedDialog" :disabled="!canDelete"><i class="fa fa-fw fa-ban"></i><span class="hidden-xs"> {{ _('Archive selected') }}</span></button>
        <button class="btn btn-warning" type="button" v-on:click="publishSelectedDialog" :disabled="!canDelete"><i class="fa fa-fw fa-globe"></i><span class="hidden-xs"> {{ _('Publish selected') }}</span></button>
        <button class="btn btn-danger" type="button" v-on:click="removeSelectedDialog" :disabled="!canDelete"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete selected') }}</span></button>
        <button class="btn btn-success" type="button" v-on:click="printDialog" :disabled="printingData" v-if="hasSelection"><i class="fa fa-fw fa-print" aria-hidden="true"></i> {{ _('Print selected') }}</button>
        <button class="btn btn-success" type="button" v-on:click="printDialog" :disabled="printingData" v-else><i class="fa fa-fw fa-print" aria-hidden="true"></i> {{ _('Print') }}</button>
        </div>
        <button class="btn btn-success" type="button" v-on:click="downloadXlsx"><i class="fa fa-fw fa-download"></i> {{ _('Download Excel file') }}</button>
      </div>
      <Datatable :url="groupedProductsUrl" :open-groups="openCategories" :search="search" :type-filter="type" :admin-tag-filter="tag" :options="tableOptions" ref="datatable" v-on:data="tableEvent" v-on:selection="rowsSelected" />
    </div>
    <LazyReservableProductListItem v-if="productToAdd" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="productToAdd.id" :product="productToAdd" :productShopId="productToAddShopId" :auto="true" :allowResourceSelection="true" v-on:productModalClosed="productModalClosed" v-on:success="reservationAdded">
      {{ productToAdd.name }}
    </LazyReservableProductListItem>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { productNeedsModal } from '~/lib/products'
import { mapActions, mapGetters } from 'vuex'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

const ProductTypeSelector = defineAsyncComponent(() => import('~/components/modals/ProductTypeSelector'))

export default defineNuxtComponent({
  data () {
    let $this = this
    const _ = useNuxtApp().$translate
    return {
      selectedCategory: null,
      groupedProducts: [],
      selectedProducts: [],
      search: '',
      type: 'all',
      tag: '',
      adminTags: null,
      categories: null,
      idCellClicked: false,
      buyCellClicked: false,
      folderEditCellClicked: false,
      printingData: false,
      requestId: '',
      productToAdd: null,
      productToAddShopId: null,
      tableOptions: {
        dataTree: true,
        selectable: false,
        parentType: 'category',
        parentField: 'category',
        rowFormatter: this.productRowFormatter(),
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 5,
          formatter: this.productNameFormatter(),
          responsive: 0,
          cellClick (e, cell) {
            if(e.target?.classList?.contains('buy-product')) {
              $this.buyCellClicked = true   
            }
          }
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: this.productTypeFormatter(),
        },
        {
          title: _('Price'),
          field: 'price',
          widthGrow: 5,
          formatter: this.numberFormatter(),
          hozAlign: 'right',
        },
        {
          title: _('Vat (%)'),
          field: 'vat',
          widthGrow: 4,
          formatter: this.vatFormatter(),
          hozAlign: 'right',
        },
        {
          title: 'ID',
          field: 'id',
          width: 70,
          cellClick (e, cell) {
            $this.idCellClicked = true
          },
          responsive: 0,
          hozAlign: 'right'
        },
        {
          title: _('Shop ID'),
          field: 'shopid',
          widthGrow: 3,
          headerSort: false,
        }],
        initialSort: [{
          column: 'type',
          dir: 'asc'
        }],
        rowClick: async (e, row) => {
          if(e.target?.classList?.contains('edit-category')) {
            $this.folderEditCellClicked = true  
            row.treeExpand()
          }
          if (row.getElement().classList.contains('row-category') && !$this.folderEditCellClicked) {

          } else if (!$this.tableOptions.selectable && !$this.idCellClicked && !$this.buyCellClicked) {
            $this.editRow(row)
          } else if ($this.buyCellClicked) {
            const el = row.getElement()
            if (row.getData().itemtype === 'product') {
              let product
              try {
                product = await this.loadProduct(row.getData().id)
              } catch(e) {
                return
              }
              if (productNeedsModal(product)) {
                $this.productToAdd = product
                $this.productToAddShopId = $this.shopId
              } else {
                let data = {
                  version: $this.version,
                  locale: $this.locale,
                  product: product,
                  shopId: $this.shopId,
                  count: 1
                }
                $this.$store.dispatch('addToBasket', data)
                .then(() => {
                  $this.showAddedToBasketNotification($this.$filters.marketingname(product))
                  $this.EventBus.$emit('showFloatingReceipt')
                })
                .catch((err) => {
                  $this.showAddedToBasketError(err)
                })
              }
            }
          } else if ($this.idCellClicked && ($this.$el.classList.contains('width-xs') || $this.$el.classList.contains('width-sm'))) {
            const el = row.getElement()
            if (row.getData().itemtype !== 'category') {
              if (el.classList.contains('active')) {
                el.classList.remove('active')
              } else{
                el.classList.add('active')
              }
            }
          }
          $this.idCellClicked = false 
          $this.buyCellClicked = false
          $this.folderEditCellClicked = false
        },
        dataTreeRowExpanded (row, level) {
          $this.setOpenCategories([...$this.openCategories.filter(c => c.id !== row.getData().id), { id: row.getData().id, name: row.getData().name }])
        },
        dataTreeRowCollapsed (row, level) {
          $this.setOpenCategories($this.openCategories.filter(c => c.id !== row.getData().id))
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    ...mapGetters(['openCategories']),
    showFilters () {
      return this.adminTags && this.adminTags.length
    },
    groupedProductsUrl () {
      return this.baseDomain + this.shopId + '/groupedproducts.json?apikey=' + this.apiKey + '&version=' + this.version + '&rawformat=true'
    },
    hasSelection () {
      return this.selectedProducts && this.selectedProducts.length > 0
    },
    canDelete () {
      return this.hasSelection
    }
  },
  methods: {
    ...mapActions([
      'setOpenCategories'
    ]),
    reservationAdded () {
      this.EventBus.$emit('showFloatingReceipt')
    },
    productModalClosed () {
      this.productToAdd = null
      this.productToAddShopId = null
    },
    loadProduct (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject(e)
          return
        }
        resolve(response.data)
        return
      })
    },
    downloadXlsx () {
      const filters = []
      if (this.hasSelection) {
        filters.push({ field: 'search', type: 'like', value: this.selectedProducts.map(p => p.id).join(',') })
      } else {
        if (this.search) {
        filters.push({ field: 'search', type: 'like', value: this.search })
        }
        if (this.type && this.type !== 'all') {
          filters.push({ field: 'type', type: '=', value: this.type })
        }
        if (this.tag) {
          filters.push({ field: 'admintag', type: '=', value: this.tag })
        }
      }
      let filterStr = ''
      if (filters.length) {
        filterStr = '&filters[]=' + filters.map(f => JSON.stringify(f)).join('&filters[]=')
      }
      window.open(this.baseDomain + this.shopId + '/products.xlsx?apikey=' + this.apiKey + filterStr)
    },
    rowsSelected (data) {
      this.selectedProducts = data
    },
    printDialog () {
      this.showDialog({
        title: this._('Product print (PDF)'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('30x30mm'),
            class: 'success',
            icon: 'file-pdf-o',
            handler: this.printData30
          },
          {
            title: this._('60x30mm'),
            class: 'success',
            icon: 'file-pdf-o',
            handler: this.printData60
          },
          {
            title: this._('Listing (A4)'),
            class: 'success',
            icon: 'file-pdf-o',
            handler: this.printDataA4
          }
        ]
      })
    },
    makeRequestId () {
      var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var ID_LENGTH = 8
      var rtn = ''
      for (var i = 0; i < ID_LENGTH; i++) {
        rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
      }
      this.requestId = rtn
    },
    printDataA4 () {
      this.printData("A4")
    },
    printData30 () {
      this.printData("30x30")
    },
    printData60 () {
      this.printData("60x30")
    },
    async printData (size) {
      this.makeRequestId()
      this.printingData = true
      let printProducts
      if (this.selectedProducts && this.selectedProducts.length > 0) {
        // Print only selected
        printProducts = this.selectedProducts
      } else {
        // Print everything
        printProducts = await axios.get(this.baseDomain + this.shopId + '/products.json?simple=true')
        printProducts = printProducts.data
      }

      let obj = {
        requestid: this.requestId,
        creator: this.user,
        type: 'product',
        title: this._('Product report'),
        time: 'now',
        start: 'today',
        end: 'today',
        format: 'pdf',
        output: 'download',
        email: '',
        categories: [],
        products: printProducts.map(product => product.id),
        producttypes: [],
        resources: [],
        saleschannels: [],
        poses: [],
        weekdays: [],
        days: [],
        months: [],
        times: [],
        enabled: 1,
        params: {
          size: size
        }
      }

      const response = await axios.post(this.baseDomain + this.shopId + '/scheduledreports.json?apikey=' + this.apiKey, obj)
    },
    openRef (ref) {
      window.open(this.baseDomain + ref.substring(1) + '?apikey=' + this.apiKey)
    },
    /* filterClass (context) {
      if (this.showFilters) {
        if (this.columnWidth === 6) {
          return 'col-md-6'
        }
        return 'col-md-3 col-sm-6'
      } else {
        return 'col-md-4 col-sm-4 col-xs-12'
      }
    },
    filterAddonClass (context) {
      if (this.showFilters) {
        return 'input-group-addon hidden-md'
      } else {
        return 'input-group-addon hidden-md' + (this.columnWidth === 6 ? ' hidden-lg' : '')
      }
    }, */
    removeSelectedDialog () {
      this.showDialog({
        title: this._('Are you sure? Selected products will be deleted permanently.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: this.removeSelected
          }
        ]
      })
    },
    removeSelected () {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        let id = this.selectedProducts[i].id
        this.remove(id)
      }
      this.selectedProducts = []
      this.tableOptions.selectable = false
    },
    async remove (id) {
      try {
        await axios.delete(this.baseDomain + this.shopId + '/products/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return this.showError(e)
      }
    },
    archiveSelectedDialog () {
      this.showDialog({
        title: this._('Are you sure?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Archive selected'),
            class: 'warning',
            icon: 'trash',
            handler: this.archiveSelected
          }
        ]
      })
    },
    archiveSelected () {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        let id = this.selectedProducts[i].id
        this.archive(id)
      }
      this.selectedProducts = []
      this.tableOptions.selectable = false
    },
    publishSelectedDialog () {
      this.showDialog({
        title: this._('Are you sure?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Publish selected'),
            class: 'warning',
            icon: 'trash',
            handler: this.publishSelected
          }
        ]
      })
    },
    publishSelected () {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        let id = this.selectedProducts[i].id
        this.publish(id)
      }
      this.selectedProducts = []
      this.tableOptions.selectable = false
    },
    publish (id) {
      this.setArchiveStatus('0', id)
    },
    archive (id) {
      this.setArchiveStatus('1', id)
    },
    async setArchiveStatus (archived, id) {
      const data = {
        id,
        archived
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/products/' + id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        return this.showError(e)
      }
    },
    editRow (row) {
      let id = row.getCell('id').getValue()
      let type = row.getData().itemtype
      let name = row.getCell('name').getValue()
      if (type === 'category') {
        this.editCategory(id, name)
      } else if (type === 'product') {
        this.editProduct(id, name)
      }
    },
    editCategory (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'CategoryDetails',
        title: this._('Category') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          categoryId: id,
          activeTab
        },
        skipState
      })
    },
    editProduct (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ProductDetails',
        title: this._('Product') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          productId: id,
          activeTab
        },
        skipState
      })
    },
    async createNewDialog () {
      this.showModal('producttypeselector', ProductTypeSelector, {
        props: {
          openCategories: this.openCategories
        },
        events: {
          selected: this.createNew
        },
        handlers: {},
        width: 800
      })
    },
    async createNew (data) {
      let response
      let d = {
        name: data.name
      }
      if (data.selectedCategory && data.selectedType !== 'category') {
        d.category = data.selectedCategory
      }
      try {
        if (data.selectedType === 'category') {
          response = await axios.post(this.baseDomain + this.shopId + '/categories.json?apikey=' + this.apiKey, d)
          if (response.data) {
            this.editCategory(response.data, data.name, 'general')
          }
        } else if (data.selectedType) {
          if (data.selectedType) {
            d.type = data.selectedType.type + '-' + data.selectedType.subtype + '-' + data.selectedType.displayedtype
          }
          response = await axios.post(this.baseDomain + this.shopId + '/products.json?apikey=' + this.apiKey, d)
          if (response.data) {
            this.editProduct(response.data, data.name, 'general')
          }
        } else if (data.selectedTemplate) {
          d.shopid = data.selectedTemplate.shopid
          d.id = data.selectedProduct.source_id
          response = await axios.post(this.baseDomain + this.shopId + '/producttemplates.json?apikey=' + this.apiKey, d)
          if (response.data) {
            this.editProduct(response.data, data.name, 'general')
          }
        } else if (data.selectedCopyProduct) {
          d.availability =  data.availability
          try {
            response = await axios.post(this.baseDomain + this.shopId + '/products/' + data.selectedCopyProduct.source_id + '/copy.json?apikey=' + this.apiKey, d)
          } catch(e) {
            return this.showError(this._('Copying the product failed!'))
          }
          if (response.data) {
            this.editProduct(response.data, data.name, 'general')
          }
        }
      } catch(e) {}
    },
    reload (message) {
      this.$refs.datatable.reload(false, message)
    },
    async loadAdminTags () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/tags.json?type=admin&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.adminTags = response.data.sort((a, b) => a.title > b.title ? 1 : -1)
    }
  },
  watch: {
    listFilterVisible () {
      this.$refs.datatable.resize()
    }
  },
  mounted () {
    this.loadAdminTags()
    let elem = document.getElementsByClassName(this.className)
    if(!this.events) {
      let events = {}
      events['productUpdate'] = debounce((message) => {
        return this.reload(message)
      }, 200)
      events['categoryUpdate'] = debounce((message) => {
        return this.reload(message)
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'ProductDetails':
            this.editProduct(message.data.productId, null, null, true)
            break
          case 'CategoryDetails':
            this.editCategory(message.data.categoryId, null, null, true)
            break
        }
      }
      events['taskUpdate'] = (message) => {
        if (message && message.data && message.data.status === 'done') {
          if (message.data.requestid === this.requestId && message.data.ref) {
            this.openRef(message.data.ref)
            this.printingData = false
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }

})

</script>